import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-arrow-up",
  "use": "icon-icon-arrow-up-usage",
  "viewBox": "0 0 8 5",
  "content": "<symbol viewBox=\"0 0 8 5\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-arrow-up\">\n<path d=\"M4.23084 0.373178L1.04218 3.91613C0.897391 4.07701 1.01156 4.33337 1.22801 4.33337H7.60533C7.82177 4.33337 7.93594 4.07701 7.79115 3.91613L4.60249 0.373178C4.50318 0.262833 4.33015 0.262833 4.23084 0.373178Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol